import { useQuery } from '@tanstack/react-query';
import { AUTHORIZED_USER_QUERY_KEYS, AuthorizedUserQueries } from '../query';
import { useUserRoleCapabilities } from '@src/stores';

type UseGetAuthorizedUsers = {
  refetchInterval?: number | false;
  requestId: number;
  version: number;
};

const useGetAuthorizedUsers = ({ requestId, version }: UseGetAuthorizedUsers) => {
  // Check user capabilities for manageAccess
  const canManageAccess = useUserRoleCapabilities.getState()?.roleCapabilities?.manageAccess;
  return useQuery({
    queryKey: [AUTHORIZED_USER_QUERY_KEYS.GET_AUTHORIZED_USER, requestId, version],
    queryFn: () => AuthorizedUserQueries.getAuthorizedUsers(requestId, version),
    enabled: canManageAccess,
  });
};

export default useGetAuthorizedUsers;
